import { render, staticRenderFns } from "./account-add-dialog.vue?vue&type=template&id=242e3fcc&scoped=true&"
import script from "./account-add-dialog.vue?vue&type=script&lang=js&"
export * from "./account-add-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242e3fcc",
  null
  
)

export default component.exports